export const UIAlert = ({ children, color = "red", className = "" }) => {
  const colors = {
    red: "text-red-800 bg-red-50 border border-red-300",
    green: "text-green-800 bg-green-50 border border-green-300",
  };
  return (
    <div
      className={`p-4 mb-4 text-sm rounded-lg ${colors[color]} ${className}`}
    >
      {children}
    </div>
  );
};
